import { ComponentPropsWithoutRef, forwardRef } from 'react';

import classNames from 'classnames';

import { Text } from '@spotify-internal/encore-web';

import styles from './SidebarSectionDescription.module.css';

export type SidebarSectionDescriptionProps = ComponentPropsWithoutRef<
  typeof Text
>;

const SidebarSectionDescription = forwardRef<
  HTMLParagraphElement,
  SidebarSectionDescriptionProps
>(({ className, children, ...rest }, ref) => (
  <Text
    ref={ref}
    as="p"
    variant="bodySmall"
    semanticColor="textSubdued"
    className={classNames(className, styles.root)}
    {...rest}
  >
    {children}
  </Text>
));

SidebarSectionDescription.displayName = 'SidebarSection.Description';

export default SidebarSectionDescription;
